import React from 'react';
import { Table } from 'reactstrap';
import { number, string, array } from 'prop-types';
import PromoGroupItems from './PromoGroupItems';

const propTypes = {
  banners: array.isRequired,
  offerId: number.isRequired,
  staticPath: string.isRequired,
};

const defaultProps = {
  banners: [],
};

const getCollectionId = (items = []) => items[0].collection;

const PromoGroup = ({ banners, offerId, staticPath }) => (
  <Table className="group-table" responsive>
    {banners.length > 0 &&
      banners.map(banner => (
        <PromoGroupItems
          key={banner.size}
          banner={banner}
          offerId={offerId}
          staticPath={staticPath}
          collectionId={getCollectionId(banner.imgs)}
        />
      ))}
  </Table>
);

PromoGroup.propTypes = propTypes;
PromoGroup.defaultProps = defaultProps;

export default PromoGroup;
